import React from 'react';
import {imageUrl} from 'helpers/ApplicationHelper';

const Tile = (props) => {
    const imgName = props.type.name + (props.type.selected? '-white': '');
    
    const style = {};
    if(!props.type.noPhoto) {
        style.backgroundImage = 'url(' + imageUrl(`jewelryBox/${imgName}.svg`)+ ')',
        style.backgroundSize = '36%'
    }
    
    return (
        <div className={"tile" + (props.type.selected ? ' selected' :'')}
            data-automation={props.type.name}
            style={style}
            onClick={() => props.click(props.type, props.type.name)}>
                <p className={(props.type.noPhoto? ' no-photo': '')}> {props.type.title} </p>
        </div>
    );
}   

export default Tile;